/**
 * To sync status control pin & android playing
 * 
 * FIXME. IMPORTANT, is it a good idea to extend this obs to use in all the AAF app?
 */
function AsyncPinObserver() {
    this.handlers = []; 
}

AsyncPinObserver.prototype = {
    
    subscribe: function(fn) {
        this.handlers.push(fn);
    },

    unsubscribe: function(fn) {
        this.handlers = this.handlers.filter(
            function(item) {
                if (item !== fn) {
                    return item;
                }
            }
        );
    },

    fire: function(o, thisObj) {
        var scope = thisObj || window;
        this.handlers.forEach(function(item) {
            item.call(scope, o);
        });
    }
}

const asyncPinObserver = new AsyncPinObserver();

export default asyncPinObserver;


// WEBPACK FOOTER //
// ./src/AAF/Pin/AsyncPinObserver.js